const CLASS_NAME = 'loci--components--form--checkbox';

export { CLASS_NAME };

export default {};
